// extracted by mini-css-extract-plugin
module.exports = {"grid":"aed17b9412--grid--iHGWT","tablet":"aed17b9412--tablet--tkBqG","desktop":"aed17b9412--desktop--RgQ5e"};